import { inject, Injectable } from '@angular/core';
import { BaseService } from '@shared/core';
import {
  IBaseValueModel,
  IParkingCategoryModel,
  IParkingModel,
  IParkingResponseModel,
  IZoneFilterModel,
} from '@pkp-g/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ParkingsApiService {
  private http = inject(BaseService);
  apiUrl = 'v1/parkings';
  categoriesUrl = 'v1/categories';

  getAllParkings(filter?: IZoneFilterModel): Observable<IParkingResponseModel> {
    return this.http.get<IParkingResponseModel>(`${this.apiUrl}`, filter);
  }

  getParkingById(id?: string): Observable<{ parking: IParkingModel }> {
    return this.http.get<{ parking: IParkingModel }>(`${this.apiUrl}/${id}`);
  }

  createParking(payload: IParkingModel): Observable<{ uuid: IBaseValueModel }> {
    return this.http.post<{ uuid: IBaseValueModel }>(`${this.apiUrl}`, payload);
  }

  editParking(id: string, payload: IParkingModel): Observable<{ uuid: IBaseValueModel }> {
    return this.http.put<{ uuid: IBaseValueModel }>(`${this.apiUrl}/${id}`, payload);
  }

  deleteParkingById(id?: string): Observable<unknown> {
    return this.http.delete<unknown>(`${this.apiUrl}/${id}`);
  }

  getCategoriesById(id?: string): Observable<Partial<IParkingCategoryModel>> {
    return this.http.get<Partial<IParkingCategoryModel>>(`${this.categoriesUrl}/${id}`);
  }
}
